// Webpack Imports
import * as bootstrap from 'bootstrap';

console.log("test me");

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();



import { Panzoom, Carousel } from '@fancyapps/ui';
import '@fancyapps/ui/dist/panzoom/panzoom.css';
import '@fancyapps/ui/dist/carousel/carousel.css';

const carouselIndex = document.querySelector('.carousel_index');
const carouselCount = document.querySelector('.carousel_count');

// Check if #myCarousel exists before initializing
const myCarouselElement = document.querySelector('#myCarousel');
if (myCarouselElement) {
  const myCarousel = new Carousel(myCarouselElement, {
    transition: 'crossfade',
    Dots: false,
    on: {
      initSlide: (_carousel, slide) => {
        slide.panzoom = new Panzoom(slide.el.querySelector('.f-panzoom'), {
          panOnlyZoomed: true,
          wheel: !/Mobi|Android/i.test(navigator.userAgent),
        });
      },
      ready: (carousel) => {
        if (carouselCount) {
          carouselCount.innerHTML = carousel.pages.length;
        }
        if (document.getElementById('carousel-caption')) {
          updateCaption(carousel);
        }
      },
      change: (carousel, to, from) => {
        if (carouselIndex) {
          carouselIndex.innerHTML = carousel.page + 1;
        }
        carousel.slides[from]?.panzoom?.reset(0.15);
        if (document.getElementById('carousel-caption')) {
          updateCaption(carousel);
        }
      },
    },
  });
}

function updateCaption(carousel) {
  const captionElement = document.getElementById('carousel-caption');
  if (!captionElement) return; // Exit if caption element does not exist

  const currentSlide = carousel.slides[carousel.page];
  const title = currentSlide.el.getAttribute('data-title');
  const descriptionElement = currentSlide.el.querySelector('.slide-description');
  const description = descriptionElement ? descriptionElement.innerHTML : '';

  captionElement.innerHTML = `<h2>${title}</h2>${description}`;
}




